(function() {
    'use strict';

angular
    .module('core')
    .directive('datepickerMkc', datepickerMkc);

function datepickerMkc(dateUtil) {
    return {
        restrict: 'E',
        link: _linker,
        require: '^datePicker'
    };

    function _linker(scope, el, attr, datepicker) {
        /* In the event of a transclusion inside an isolated-scope-directive the transcluding
           directive's scope will always be the previous sibling.
           This approach forced me to use an angular private property but, at least, we're not
           polluting the controller's scope (when using a shared directive-controller we can't
           create an isolated scope because we're on the same element) */
        const tScope = scope.$parent;
        const dateEl = datepicker.dateEl;

        scope = tScope.currentDate;

        dateEl.on('keydown', function switchToTab(event) {
            /* If we have two datepicker on the same page and we are concurrently updating them
               both the update event on the second dp will show the date selection div this will
               forcefully hide it */
            if (event.which === 13) {
                $('#ui-datepicker-div').fadeOut('fast');
            }

            if (event.which === 9) {
                tScope.$apply(function() {
                    tScope.select({ date: dateEl.datepicker('getDate') });
                });
            }
        });

        tScope.$watch('currentDate', function(val) {
            if (val) {
                dateEl.datepicker('setDate', dateUtil.parseDate(tScope.currentDate));
            }
        });

        tScope.$on('$destroy', function() {
            dateEl.off('input');
            dateEl.off('blur');
            dateEl.off('keydown');
        });
    }
}
})();
